import React, { useState, useEffect } from "react";
import "./Setup1.css";
import { useStateValue } from "./StateProvider";
import Player from "./Player";
import { Link } from "react-router-dom";
import "react-widgets/dist/css/react-widgets.css";

function SetUp() {
  const [{ players }, dispatch] = useStateValue();
  const [player, setPlayer] = useState("");

  useEffect(() => {
    localStorage.setItem("players", JSON.stringify(players));
  }, [players]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!player) {
      alert("Please add a player");
      return;
    }

    addPlayer();
    setPlayer("");

  };

  const addPlayer = () => {
console.log("id",players?.length +1)
    dispatch({
      type: "ADDPLAYER1",
      player:{
      id: players?.length +1,
      first: player,}
    });
  };

  return (
    <div className="setup__container">
      <div className="setup__heading">Enter Players</div>
      <div className="player__lineitems">
        {players?.map((player) => (
          <div >
            <Player key={player.id}  id={player.id} />
           </div>
        ))}
      </div>
      <form className="add-form" onSubmit={onSubmit}>
        <div className="form-control">
          {/* <label>Player Name</label> */}
          <input
            className="input__box"
            type="text"
            placeholder="Enter Player"
            value={player}
            onChange={(e) => setPlayer(e.target.value)}
          />
        </div>
        <input type="submit" value="Add Player" className="btn btn-block" />
      </form>
      <Link to="/wagers">
      <button className="btn__wagers">Group Wagers</button>
      </Link>
    </div>
  );
}

export default SetUp;
